/* ============================================================
   Aurore — Policy Page JS
   File : assets/policy-page.js
   ============================================================ */
(function () {
  'use strict';

  /* Smooth scroll for in-page anchors */
  document.querySelectorAll('.ap-content-card a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
    });
  });

  /* Fade-in content card on scroll */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.06 });

    document.querySelectorAll('.ap-content-card').forEach(function (el) {
      el.style.cssText += ';opacity:0;transform:translateY(14px);transition:opacity 0.5s ease,transform 0.5s ease';
      io.observe(el);
    });
  }
})();